import { MENU } from 'src/app/constant/menu';

export const Role = {
  ADMIN: 'ADMIN',
  AGENCY: 'AGENCY',
  STAFF: 'STAFF',
  TECHNICIAN: 'TECHNICIAN',
  LEAD_MARKETING: 'LEAD_MARKETING',
  ACCOUNTANT: 'ACCOUNTANT',
  SALE: 'SALE',
  CUSTOMER_CARE: 'CUSTOMER_CARE',
  USER: 'USER',
  DRIVER: 'DRIVER'
};

const MENU_ALL = MENU;
const MENU_NO_DEVICE_AGENCY_CMS = MENU.filter(
  item =>
    item.value !== 'device' &&
    item.value !== 'agency' &&
    item.value !== 'cms-camera'
);
const MENU_NO_CMS_ROUTING_CAMERA = MENU.filter(
  item =>
    item.value !== 'cms-camera' &&
    item.value !== 'routing' &&
    item.value !== 'camera'
);
const MENU_NO_CMS = MENU.filter(
  item =>
    item.value !== 'cms-camera'
);


const DEVICE_ITEM = { label: 'Quản trị thiết bị', route: '/manage/devices' };
const DEVICE_ITEM_COLLAPSE = (items, type = 'device') => ({
  label: 'Quản trị thiết bị',
  isCollapse: true,
  items,
  type
});

export const ROLE_PRIORITY = [
  Role.ADMIN,
  Role.AGENCY,
  Role.STAFF,
  Role.TECHNICIAN,
  Role.LEAD_MARKETING,
  Role.ACCOUNTANT,
  Role.SALE,
  Role.CUSTOMER_CARE,
  Role.USER,
  Role.DRIVER
];

export const getRoleSelectorFlags = authSlice => ({
  [Role.ADMIN]: authSlice.isAdmin,
  [Role.AGENCY]: authSlice.isAgency,
  [Role.STAFF]: authSlice.isStaff,
  [Role.TECHNICIAN]: authSlice.isTechnician,
  [Role.LEAD_MARKETING]: authSlice.isLeadMarketing,
  [Role.ACCOUNTANT]: authSlice.isAccountant,
  [Role.SALE]: authSlice.isSale,
  [Role.CUSTOMER_CARE]: authSlice.isCustomerCare,
  [Role.USER]: authSlice.isUser,
  [Role.DRIVER]: authSlice.isDriver
});

export const resolveRole = authSlice => {
  const flags = getRoleSelectorFlags(authSlice);
  return ROLE_PRIORITY.find(role => flags[role]) || null;
};

export const ROLE_CONFIG = {
  [Role.ADMIN]: {
    mainMenu: MENU_ALL,
    showManageDropdown: true,
    showReportMenu: true,
    showDeviceLookupMenu: true,
    manageItems: () => [
      { label: 'Thống kê', route: '/manage/statistics/warehouse-transfer' },
      { label: 'Quản trị nhân viên', route: '/manage/service-staffs' },
      { label: 'Quản trị khách hàng', route: '/manage/users' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM,
      { label: 'Quản trị quảng cáo', route: '/manage/broadcasts-schedules' },
      { label: 'Phản hồi khách hàng', route: '/manage/feedbacks' },
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' },
      { label: 'Quản trị bản đồ', route: '/manage/geocode-sources' },
      { label: 'Nhật ký hoạt động', route: '/manage/action-logs' }
    ],
    mobileManageItems: ({ mobile }) => [
      { label: 'Thống kê', isCollapse: true, items: mobile.statistics, type: 'statistics' },
      { label: 'Quản trị nhân viên', route: '/manage/service-staffs' },
      { label: 'Quản trị khách hàng', route: '/manage/users' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceAdmin),
      { label: 'Quản trị quảng cáo', isCollapse: true, items: mobile.advertisement, type: 'advertisement' },
      { label: 'Phản hồi khách hàng', route: '/manage/feedbacks' },
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' },
      { label: 'Quản trị bản đồ', route: '/manage/geocode-sources' },
      { label: 'Nhật ký hoạt động', route: '/manage/action-logs' }
    ]
  },

  [Role.AGENCY]: {
    mainMenu: MENU_NO_DEVICE_AGENCY_CMS,
    showManageDropdown: true,
    showReportMenu: false,
    showDeviceLookupMenu: true,
    manageItems: ({ shouldShowAgencyItem }) => [
      { label: 'Thống kê', route: '/manage/statistics/warehouse-transfer' },
      DEVICE_ITEM,
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      ...(shouldShowAgencyItem
        ? [{ label: 'Quản trị đại lý', route: '/manage/agencies' }]
        : []),
      { label: 'Quản trị nhân viên', route: '/manage/service-staffs' },
      { label: 'Quản trị bán hàng & Thu tiền', route: '/manage/sales-orders' },
      { label: 'Quản trị bảo hành', route: '/manage/sales-orders?tab=warranty' },
      { label: 'Quản trị lái xe', route: '/manage/driver' },
      { label: 'Nhật ký hoạt động', route: '/manage/action-logs' }
    ],
    mobileManageItems: ({ mobile, shouldShowAgencyItem }) => [
      { label: 'Thống kê', isCollapse: true, items: mobile.statistics, type: 'statistics' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      ...(shouldShowAgencyItem
        ? [{ label: 'Quản trị đại lý', route: '/manage/agencies' }]
        : []),
      { label: 'Quản trị nhân viên', route: '/manage/service-staffs' },
      { label: 'Quản trị bán hàng & Thu tiền', route: '/manage/sales-orders' },
      { label: 'Quản trị bảo hành', route: '/manage/sales-orders?tab=warranty' },
      { label: 'Quản trị lái xe', isCollapse: true, items: mobile.driver, type: 'driver' },
      { label: 'Nhật ký hoạt động', route: '/manage/action-logs' }
    ]
  },

  [Role.STAFF]: {
    mainMenu: MENU_NO_DEVICE_AGENCY_CMS,
    showManageDropdown: true,
    showReportMenu: true,
    showDeviceLookupMenu: false,
    manageItems: () => [DEVICE_ITEM],
    mobileManageItems: ({ mobile }) => [DEVICE_ITEM_COLLAPSE(mobile.deviceOthers)]
  },

  [Role.TECHNICIAN]: {
    mainMenu: [],
    showManageDropdown: true,
    showReportMenu: false,
    showDeviceLookupMenu: false,
    manageItems: () => [
      DEVICE_ITEM,
      { label: 'Quản trị bảo hành', route: '/manage/sales-orders?tab=warranty' }
    ],
    mobileManageItems: ({ mobile }) => [
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị bảo hành', route: '/manage/sales-orders?tab=warranty' }
    ]
  },

  [Role.LEAD_MARKETING]: {
    mainMenu: [],
    showManageDropdown: true,
    showReportMenu: false,
    showDeviceLookupMenu: true,
    manageItems: () => [
      { label: 'Quản lý sale', route: '/manage/service-staffs' },
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM,
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ],
    mobileManageItems: ({ mobile }) => [
      { label: 'Quản lý sale', route: '/manage/service-staffs' },
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ]
  },

  [Role.ACCOUNTANT]: {
    mainMenu: [],
    showManageDropdown: true,
    showReportMenu: true,
    showDeviceLookupMenu: false,
    manageItems: () => [
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM,
      { label: 'Quản trị nhân viên', route: '/manage/service-staffs' }
    ],
    mobileManageItems: ({ mobile }) => [
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ]
  },

  [Role.SALE]: {
    mainMenu: [],
    showManageDropdown: true,
    showReportMenu: false,
    showDeviceLookupMenu: true,
    manageItems: () => [
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM,
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ],
    mobileManageItems: ({ mobile }) => [
      { label: 'Quản trị khách hàng', route: '/manage/customers' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ]
  },

  [Role.CUSTOMER_CARE]: {
    mainMenu: MENU_NO_CMS_ROUTING_CAMERA,
    showManageDropdown: true,
    showReportMenu: false,
    showDeviceLookupMenu: true,
    manageItems: () => [
      { label: 'Quản trị khách hàng', route: '/manage/users' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM,
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ],
    mobileManageItems: ({ mobile }) => [
      { label: 'Quản trị khách hàng', route: '/manage/users' },
      { label: 'Quản trị đại lý', route: '/manage/agencies' },
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị kinh doanh', route: '/manage/sales-orders' }
    ]
  },

  [Role.USER]: {
    mainMenu: MENU_ALL,
    showManageDropdown: true,
    showReportMenu: true,
    showDeviceLookupMenu: false,
    manageItems: () => [
      DEVICE_ITEM,
      { label: 'Quản trị lái xe', route: '/manage/driver' },
      { label: 'Quản trị tài khoản lái xe', route: '/manage/accounts-driver' },
      { label: 'Quản trị vùng giám sát', route: '/manage/safe-zone' }
    ],
    mobileManageItems: ({ mobile }) => [
      DEVICE_ITEM_COLLAPSE(mobile.deviceOthers),
      { label: 'Quản trị lái xe', isCollapse: true, items: mobile.driver, type: 'driver' },
      { label: 'Quản trị vùng an toàn', route: '/manage/safe-zone' }
    ]
  },

  [Role.DRIVER]: {
    mainMenu: MENU_NO_DEVICE_AGENCY_CMS,
    showManageDropdown: true,
    showReportMenu: true,
    showDeviceLookupMenu: false,
    manageItems: () => [DEVICE_ITEM],
    mobileManageItems: ({ mobile }) => [DEVICE_ITEM_COLLAPSE(mobile.deviceOthers)]
  }
};

const EMPTY_CONFIG = {
  mainMenu: [],
  showManageDropdown: false,
  showReportMenu: false,
  showDeviceLookupMenu: false,
  manageItems: () => [],
  mobileManageItems: () => []
};

export const getRoleConfig = role => ROLE_CONFIG[role] || EMPTY_CONFIG;
